import { useContext } from 'react';
import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { LançamentosContext } from 'contexts/LançamentosContext';
import { useModal } from 'components/Modals';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Button from 'components/Button';

const FechamentoModal = ({ onSubmit }) => {
  const defaultValues = {
    datai: null,
    dataf: null,
    planoentidade_id: null,
    ctaresultado_id: null,
    ctalucro_id: null,
    ctaprejuizo_id: null,
  };
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { postLoading } = useContext(LançamentosContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <>
      <DialogTitle>Lançar Fechamento</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12} sm={6}>
            <InputMask
              name="datai"
              control={control}
              label="Data de Lançamento Inicial"
              type="date"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="dataf"
              control={control}
              label="Data de Lançamento Final"
              type="date"
            />
          </Grid>
          <Grid item xs={12}>
            <VirtualDrop
              name="planoentidade_id"
              control={control}
              label="Plano de Lançamento"
              options={drops?.Planoentidade}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <VirtualDrop
              name="ctaresultado_id"
              control={control}
              label="Conta de Resultado"
              options={drops?.Planoconta}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <VirtualDrop
              name="ctalucro_id"
              control={control}
              label="Conta de Lucro"
              options={drops?.Planoconta}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <VirtualDrop
              name="ctaprejuizo_id"
              control={control}
              label="Conta de Prejuízo"
              options={drops?.Planoconta}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          loading={postLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Confirmar
        </Button>
        <Button color="secondary" variant="contained" onClick={closeModal}>
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default FechamentoModal;
